import { appStoreCloudApis } from 'Api/index';
import qs from 'qs'
import { store } from 'Store/store.index';
import {
  isPdfOnlineDomain,
  isCommonFeatureDomain,
  isDemo4Domain,
  isCNDomain, isJPDomain, getFoxitStoreDomain,
} from 'Utils/utils';
import {APP_CODES_OR_ORG_CODES_ONLINE} from 'constants/index'
import HmacMD5 from 'crypto-js/hmac-md5';
import { APP_IDENTIFIES, APP_TARGETS, /* APP_SHOPPING_URLS, */ APP_SHOPPING_DOMAIN_URLS} from "Constants/account.constant";
import _isNil from 'lodash/isNil';
import { BUNDLE_PRODUCT_CODE, PRODUCT_INCLUDE_CLOUD } from 'Components/dialogs/PaymentDlg/payment.constants';
/**
 * @typedef Plan
 * @property {String} stripe_plan_id
 * @property {String} plan_name
 * @property {String} app_code
 * @property {String} type
 * @property {String} value {value = plan.app_code +"-" +plan.type;}
 * @property {String} price
 * @property {String} currency
 * @property {String} original_price
 * @property {String} original_price_mac
 * @property {String} can_change
 * @property {String} effective_date
 * @property {String} expiration_date
 */

 /**
 * @typedef AppPlan
 * @property {String} app_code "phantom_ga_business"
 * @property {String} plan_type "monthly"
 * @property {String} plan_id "phantom_ga_business_monthly_1_14_1469694988"
 * @property {String} status "active"
 * @property {String} next_plan
 * @property {String} next_plan_time
 * @property {String} updated
 * @property {Object} expiredDate
 * @property {String} stripe_subscription_id
 */
/**
 * @typedef SubscribedApps
 * @property {String} app_name
 * @property {AppPlan[]} subscriptions
 */

/**
 * @typedef SubscribeInfo
 * @property {Boolean} isSubscribed
 * @property {Boolean} redeem_subscription
 * @property {SubscribedApps[]} subscribedApps
 * @property {AppPlan[]} expiredSubscriptions
 * @property {String} phantom_online_trial_start
 * @property {Number} phantom_online_trial_start_timestamp
 * @property {Number} current_timestamp
 * @property {Number} remain_days
 * @property {Boolean} can_use_paid_service
 */

export class AccountService {
  constructor() {}
  /** Plan: {
        "stripe_plan_id": "phantom_ga_standard_monthly_1_60_1474957310",
        "plan_name": "每月",
        "app_code": "phantom_ga_standard",
        "type": "monthly",
        "user_count": 1,
        "price": 6000,
        "effective_date": "2016-09-27 00:00:00",
        "expiration_date": "2049-12-31 23:59:59",
        "can_change": 1,
        "created": "2016-09-27 06:21:50",
        "updated": null,
        "extra_unit_price": null,
        "trial_period_days": null,
        "currency": "CNY",
        "original_price": null,
        "original_price_mac": null
    } */

  /**
   *
   *
   * @param {String[]} appCodes
   * @returns {Promise<{key1:Plan,...}>}
   *
   */
  getPlans(appCodes) {
    return new Promise((resolve, reject) => {
      const { full } = store.appStore.lng;
      let requests = [];
      appCodes.forEach((code) => {
        requests.push(appStoreCloudApis.getPlan(code, full));
      });
      Promise.all(requests).then((plansMap) => {
          //let list = [];
          let map = {}
          plansMap.forEach(({app_code, plans}) => {
            //let appPlan = {}
            plans.forEach(plan=>{
              //appPlan[plan.value] = plan
              map[app_code+ '-' + plan.type] = plan;
            })
            //plans && plans.length > 0 && list.push(...plans);
          });
          resolve(map);
        }).catch((err) => {
          console.error('TCL: AccountService -> _readPlan -> err', err);
          reject(err)
        });
    });
  }

  /**
   *
   *
   * @param {Array<Plan>} plans
   * @returns {{eduPlan:Plan,selectedPlan: Plan, plans:Array<Plan>}}
   */
  parsePlans(plans) {
    if (!plans) {
      return;
    }
    let details = {
      eduPlan: null,
      selectedPlan: null,
      plans: [],
    };
    let select = false;
    plans.forEach((plan) => {
      if (!plan.app_code || !plan.type) {
        return;
      }
      if (!select && plan.app_code === 'phantom_ga_online_b' && plan.type === 'yearly') {
        details.selectedPlan = plan; // plan.app_code  +"-"+plan.type
        select = true;
      }
      if (plan.app_code == 'phantom_ga_education') {
        details.eduPlan = plan;
      }
      if (plan.app_code == 'phantom_ga_business') {
        plan.yearlyBusinessPrice = plan.price / 100.0;
      }
      plan.value = plan.app_code + '-' + plan.type;
      details.plans.push(plan);
      //$("#sub_plan_code li[name="+value+"]").removeClass("hide");
    });
    return details;
  }
  /**
   *
   * @param {String[]} appCodes
   */
  _readPlan(appCodes) {
    const { full } = store.appStore.lng;
    let requests = [];
    appCodes.forEach((/* code */) => {
      requests[i] = appStoreCloudApis.getPlan(appCodes[i], full);
    });
    Promise.all(requests)
      .then((values) => {
        _planInfo = values;
        this.initPlan(_planInfo);
      })
      .catch((err) => {
        console.error('TCL: AccountService -> _readPlan -> err', err);
      });
    //_initPlaymentEle();
  }

  initPlan(_planInfo) {
    if (!_planInfo) {
      return;
    }
    let select = false;
    let hasEducation = false;
    let yearlyBusinessPrice = 0;
    for (let i in _planInfo) {
      let plans = _planInfo[i];
      for (let j in plans) {
        let plan = plans[j];
        if (select == false && plan.app_code == 'phantom_ga_online_b' && plan.type == 'yearly') {
          $('#sub_plan_code .sub_plan_content').html($('#sub_plan_code li[name=' + plan.app_code + '-' + plan.type + ']').html());
          $('#sub_plan_code .sub_plan_content').data('selected', plan.app_code + '-' + plan.type);
          select = true;
        }
        if (!plan.app_code || !plan.type) {
          continue;
        }
        if (plan.app_code == 'phantom_ga_education') {
          hasEducation = true;
        }
        if (plan.app_code == 'phantom_ga_business') {
          yearlyBusinessPrice = plan.price / 100.0;
        }
        let value = plan.app_code + '-' + plan.type;
        $('#sub_plan_code li[name=' + value + ']').removeClass('hide');
      }
    }
    if (hasEducation) {
      $('#sub_plan_code li:not(.education)').addClass('hide');
    }
    $('#sub_plan_code  .hide').remove();
    /*if(!isWindowPC()) {
            $("#sub_plan_code  .not-online").remove();
        }*/
    let subscribeType = getCookie('subscribeType');
    if (subscribeType) {
      $('#sub_plan_code li[name=' + subscribeType + ']').addClass('selected');
      $('#sub_plan_code li[name=' + subscribeType + ']').trigger('click');
      delCookie('subscribeType');
    } else {
      if ($('#sub_plan_code li').length >= 2) {
        $($('#sub_plan_code li')[1]).trigger('click');
      } else {
        $('#sub_plan_code li[name="phantom_ga_education-yearly"]').trigger('click');
        let businessCent = ((yearlyBusinessPrice * 100) % 100).toString();
        if (businessCent.length == 1) {
          businessCent = '0' + businessCent.toString();
        }
        $('#education-business-price')
          .removeClass('hide')
          .css({
            color: '#f5ad29',
            'font-size': '40px',
            height: '40px',
            position: 'absolute',
            left: '0px',
            'margin-top': '20px',
          })
          .html(
            "<sup style='font-size:15px;top:-1rem;'>U$</sup>" +
              parseInt(yearlyBusinessPrice) +
              "<sup style='font-size:12px;top:-1rem;'>" +
              businessCent +
              '</sup>',
          )
          .append(
            '<div style="position:  absolute;height: 2px;width: 60px;background-color: #f5ad29;left: 50%;top: 50%;margin-left: -30px;transform: rotate(30deg);"></div>',
          );
      }
    }
  }

  /**
   *
   *
   * @param {*} callback
   * @memberof AccountService
   */
    doGetSubscribeInfo(preload) {
      return new Promise((resolve, reject) => {
        appStoreCloudApis.getPhantomOnlineSub(preload).then(async (result) => {
          if (result && result.ret === 0 ) {
            return resolve(result.data)
          }
          reject(result)
        })
          .catch((err) => {
            if(err.ret===100007 && err.message.toLowerCase().includes('token')){
              window.localStorage.setItem('tk_er','1');
            }
            console.log('===>>> ~ AccountService ~ doGetSubscribeInfo ~ err', err);
          });
      })
    }

  /*
  doGetUserAllApps(callback){
    appStoreCloudApis.getUserAllApps().then(({ apps }) => {
        callback && callback({ret:0, apps })
        
      }).catch(() => {
      callback && callback({ ret: 404 })
    });
  }*/
  /**
   *
   *
   * @param {SubscribeInfo} subscribeInfo
   * @returns
   */
  getSubscribedApps(subscribeInfo) {
    //let subInfo =  WebPDF.AccountInstance.getSubInfo();
    let apps = [];
    if (!subscribeInfo) {
      return apps;
    }
    /*if(!subInfo.isSubscribed){
        return null;
    }*/

    let isNeedAddSubscribeApp = (app_code) => {//#ONLINERD-2647
      const {isEdu} = store.userStore;
      if (!(isPdfOnlineDomain() || isCommonFeatureDomain()) || isEdu) return true;
      let bNeed = false;
      APP_CODES_OR_ORG_CODES_ONLINE.forEach((code) => {
        if (code == app_code) return bNeed = true;
      });
      return bNeed;
    }

    let appsCovid2019 =[]
    let expiredDate = null;
    let app = {};
    for (let i in subscribeInfo.subscribedApps) {
      let subApp = subscribeInfo.subscribedApps[i];
      for (let j in subApp.subscriptions) {
        let sub = subApp.subscriptions[j];
        // sub.status => 'active' 'given' 'prepayment-active' 'offline-purchase'
        if (sub.status === "trialing"){
          sub.status = 'trail';
        }else {
          sub.status = 'active';
        }
        app = {
          order_created: sub.created,
          order_updated: sub.updated,
          app_code: sub.app_code, //"phantom_ga_business"
          plan_type: sub.plan_type, //"monthly"
          status: sub.status, // "active"
          plan_id: sub.plan_id, // "phantom_ga_business_monthly_1_14_1469694988"
          stripe_subscription_id: null,
          expiredDate: null,
          org_code: sub.org_code?sub.org_code:''
        };

        // sub.next_plan === 'canceled' sub.next_plan === 'offline-purchase-expired'
        if (sub.next_plan_time) {
          app.expiredDate = parseInt(sub.next_plan_time) * 1000;
          //continue;
        }
        if (sub.stripe_subscription_id && sub.stripe_subscription_id.length > 0) {
          app.stripe_subscription_id = sub.stripe_subscription_id;
          !sub.plan_id && sub.stripe_plan_id && (app.plan_id = sub.stripe_plan_id)
          !sub.plan_id && sub.stripe_subscription_id && (app.plan_id = sub.stripe_subscription_id)
        }
        if(!app.plan_type){
          app.plan_type = 'monthly'
          if (sub && sub.stripe_plan_id && sub.stripe_plan_id.indexOf('yearly') > 0) app.plan_type = 'yearly';
        }
        if (sub.next_plan === 'canceled') {
          app.stripe_subscription_id = null;
        }
        // covid2019
        if(sub.org_code === "covid2019"){
          sub.status = 'trail'
          appsCovid2019.push(app);
          continue;
        }
        if (isNeedAddSubscribeApp(app.app_code)) apps.push(app);
        continue;
      }
    }
    //
    if(appsCovid2019.length>0 && isNeedAddSubscribeApp("covid2019")){
      apps.push(...appsCovid2019)
    }

    // 订阅过期的app
    let status = '';

    if (subscribeInfo.expiredSubscriptions && subscribeInfo.expiredSubscriptions.length > 0) {
      status = 'expired';
      let plan_type = '';
      subscribeInfo.expiredSubscriptions.forEach((sub)=>{
        if (!sub.updated) {
          return false;
        }
        plan_type = sub.plan_type;
        if(sub.plan_id){

        }
        // "stripe_plan_id": "phantom_ga_standard_monthly_1_60_1474957310",
        if (sub.stripe_plan_id) {
          !sub.plan_id && sub.stripe_plan_id && (sub.plan_id = sub.stripe_plan_id);
          !sub.plan_id && sub.stripe_subscription_id && (sub.plan_id = sub.stripe_subscription_id)
          //
        }
        if(!plan_type){
          plan_type = 'monthly'
          if (sub.stripe_plan_id.indexOf('yearly') > 0) plan_type = 'yearly';
        }
        app = {
          app_code: sub.app_code, //"phantom_ga_business"
          plan_type: plan_type, //"monthly"
          status: status, // "active"
          plan_id: sub.plan_id, // "phantom_ga_business_monthly_1_14_1469694988"
          expiredDate: sub.updated,
        };
        if (isNeedAddSubscribeApp(app.app_code)) apps.push(app);
        //return true
      })
    }
    if (apps.length > 0) return apps;
    if (subscribeInfo.remain_days < 0) {
      status = 'trailExpired';
    } else if(subscribeInfo.remain_days > 0) {
      status = 'trail';
    } else if(subscribeInfo.remain_days===0){
      status = 'firstFree';
    }
    expiredDate = subscribeInfo.current_timestamp *1000 + subscribeInfo.remain_days*24*60*60*1000;
    app = {
      app_code: '', //"phantom_ga_business"
      plan_type: '', //"monthly"
      status: status, // "active"
      plan_id: '', // "phantom_ga_business_monthly_1_14_1469694988"
      expiredDate: expiredDate,
    };
    apps.push(app);
    return apps;
  }
  /**
   *
   * @param {SubscribeInfo} subsAppInfo
   * @returns  {{status}}   {
   *   status: active, expired, trailExpired, trail
   * }
   */
  getSubStatus(subsAppInfo, apps) {
    let status = 'trail';

    let checkSubscribe = (isSubscribed, apps) => {//#ONLINERD-2647
      const { isEdu } = store.userStore;
      if (!isSubscribed || !(isPdfOnlineDomain() || isCommonFeatureDomain()) || isEdu) return isSubscribed;
      let checkSubscribed = false;
      apps.forEach((app) => {
        if (app && ['active', 'trail'].includes(app.status)) return checkSubscribed = true;
      });
      return checkSubscribed;
    };

    const getCurAppCode = () => {
      const { isEdu } = store.userStore;
      return isEdu ? 'pdf_editor_cloud_education' : 'phantom_ga_online';
    };

    do {
      if (!subsAppInfo) {
        break;
      }
      const rd = subsAppInfo.remain_days;
      const { trial_from } = subsAppInfo;
      const isBundleTrial = trial_from === 'bundle_trial';
      if (!checkSubscribe(subsAppInfo.isSubscribed, apps)) {
        if (isCNDomain() || isJPDomain()) {
          if (_isNil(rd)) {
            status = 'expired';
          } else if (rd < 0) {
            status = 'trailExpired';
          } else if (rd >= 0) {
            status = 'trail';
          }
        } else {
          if (_isNil(rd)) {
            status = 'noFirstTrailed';
          } else if (rd < 0) {
            status = 'trailExpired';
          } else if (rd >= 0) {
            status = 'trail';
            if (!isBundleTrial && 'subscribedApps' in subsAppInfo && 'expiredSubscriptions' in subsAppInfo) {
              const { subscribedApps, expiredSubscriptions } = subsAppInfo;
              if (!subscribedApps.length && expiredSubscriptions.length && !isCNDomain() && !isJPDomain()) {
                status = 'expired';
              }
            }
          }
        }

        if (status === 'trailExpired' && subsAppInfo.expiredSubscriptions && subsAppInfo.expiredSubscriptions.length > 0) {
          status = 'expired';

          const lastProduct = subsAppInfo.expiredSubscriptions.findLast(i => i.app_code === getCurAppCode());
          if (lastProduct) {
            const { cancel_type, app_code } = lastProduct;
            if (cancel_type === 'trialing_cancel' && app_code === 'phantom_ga_online') {
              status = 'trailExpired';
            }
          }
        }

        if (_isNil(trial_from) && 'expiredSubscriptions' in subsAppInfo && subsAppInfo.expiredSubscriptions.length > 0) {
          const { expiredSubscriptions = [] } = subsAppInfo;
          const isBundleExpired = expiredSubscriptions.some(({ app_code }) => BUNDLE_PRODUCT_CODE.includes(app_code));
          if (isBundleExpired) {
            status = 'expired';
            store.accountStore.setTrialFrom('bundle_trial');
          }

          const isProPlusExpired = expiredSubscriptions.some(({ app_code }) => PRODUCT_INCLUDE_CLOUD.includes(app_code));
          if (isProPlusExpired) {
            status = 'expired';
          }
        }

        break;
      } else if (rd >= 0) {
        const list = apps.filter(i => i.app_code === getCurAppCode() && i.status === 'trail');
        if (list.length) {
          status = 'trail';
        } else {
          status = 'active';
        }
        break;
      }
      // subscribedApps
      status = 'active';
    } while (false);
    return {
      status
    };
  }
  getSubStripeId(data,apps){
    let resId = '';
    if(data && 'expiredSubscriptions' in data && data.expiredSubscriptions.length){
      const {expiredSubscriptions} = data;
      const hadSubscribedList = expiredSubscriptions.filter(i=>i.app_code==='phantom_ga_online' && i.stripe_subscription_id);
      if(hadSubscribedList.length){
        const res = hadSubscribedList.pop();
        resId = res.stripe_subscription_id;
      }
    }
    if(apps.length){
      const onlineList = apps.filter(i=>i.app_code==='phantom_ga_online' && i.stripe_subscription_id);
      if(onlineList.length){
        const res = onlineList.pop();
        resId = res.stripe_subscription_id;
      }
    }
    return resId;
  }

  doMockSubscribe(status, callback){
    import (/* webpackChunkName: "subscribe.mock" */'@/__mock__/subscribe/index.js').then(({activeResult,
      expiredResult,
      trailResult,
      trailExpiredResult, redeemResult})=>{

      let map = {
        active:activeResult,
        expired:expiredResult,
        trail:trailResult,
        redeem: redeemResult,
        trailExpired:trailExpiredResult
      }

      callback && callback(map[status])

    }).catch((err)=>{
      console.error("TCL: doMockSubscribe -> err", err)

    })
  }

  async doActivate(license, callback, error){
    let result = await appStoreCloudApis.doLicenseCodeRedeem(license);
    if(result && result.ret === 0){
      callback && callback(result);
      return;
    }
    error && error(result);
  }

  getUserMetadata(key, callback, errCallback){
    appStoreCloudApis.getUserMetadata(key).then((data)=>{
      if(data && data.id){
        callback && callback(data.value);
        return;
      }
      errCallback && errCallback(data)
    }).catch((err)=>{
      errCallback && errCallback(err)
    })
  }

  setUserMetadata(key, value, callback, errCallback){
    appStoreCloudApis.setUserMetadata(key, value).then((data)=>{
      if(data && data.id){
        callback && callback(data.value);
        return;
      }
      errCallback && errCallback(data)
    }).catch((err)=>{
      errCallback && errCallback(err)
    })
  }

  diffTime(startDate,endDate) {
    let diff = (endDate - startDate);
    if ( diff <0 )
        return "00:00:01";
    // day
    // let days=Math.floor(diff/(24*3600*1000));

    // hour
    let leave1=diff%(24*3600*1000);
    let hours=Math.floor(leave1/(3600*1000));
    if (hours < 10){
        hours = "0" + hours;
    }
    // min
    let leave2=leave1%(3600*1000);
    let minutes=Math.floor(leave2/(60*1000));
    if (minutes < 10){
        minutes = "0" + minutes;
    }
    // second
    let leave3=leave2%(60*1000);
    let seconds=Math.round(leave3/1000);
    if (seconds < 10){
        seconds = "0" + seconds;
    }

    let diffValue = hours + ":"+ minutes + ":" + seconds;
    return diffValue;
  }
  getWaitingTime(timestamp, now, duration) {
    let last = timestamp + duration ;
    if ( (last - now) <0 )
        return "00:00:00";
    let diff = this.diffTime(now, last);
    return diff;
  }

  getErrorString(ret, ns){
    let code = 500;
    let errString = null;
    if(typeof ret == 'object' && ret.ret){
        code = ret.ret;
    } else if (typeof ret == 'number'){
        code = ret;
    }
    if(ns == 'licenseCodeRedeem'){
        switch(code){
            case 111009:
            case 111010:
            case 111011:
            case 111012:
            case 111013:
            case 111014:
            case 111015:
            case 999999:
            {
                errString = i18n.t("pro:error.licenseCodeRedeem."+code);
                break;
            }
            default:{
                errString = i18n.t("pro:error.unknown");
            }
        }
        return errString;
    }

    switch(code){
        case 112007:
        case 112008:
        case 112009:
        case 2100031:
        case 112003:
        case 112010:
        {
            errString = i18n.t("pro:error."+code);
            break;
        }

        case 999999:{
            if(ret.msg == i18n.t("pro:error.subscription.onlyEducationMail")){
                errString = i18n.t("pro:error.subscription.onlyEducationMail");
                break;
            }
            if(status == 401){
                errString = i18n.t("pro:error.unauthorized");
            }
        }
        default:{
            errString = i18n.t("pro:error.unknown");
        }
    }

    return errString;
  }

  getShoppingUrl(/* {targetUrl} */){
    let isUS = isPdfOnlineDomain();
    let isEU = isCommonFeatureDomain();
    let isDemo4 = isDemo4Domain();

    let url;
    if(isUS || isEU || isDemo4){
      url = `${isDemo4? APP_SHOPPING_DOMAIN_URLS.demo4: APP_SHOPPING_DOMAIN_URLS.us}/shopping.html` ;
    }

    return url;
  }


  /**
   * app_code: one of "phantom_ga_business","phantom_ga_standard","phantom_ga_online","phantom_ga_education"
   * target : one of 'app-detail' 'my-order' 'app-list' 'my-cards' 'my-invoices'
   * @param {*} {app_code, planType='', target}
   */
  getAppShoppingTargetUrlByNexstGo({app_code, planType='', target}, callback){
    //http://www.foxitsoftware.com/shopping.html  cmsen.foxitsoftware.cn
    let url = this.getShoppingUrl();
    if(!url){
      return callback && callback('');
    }
    let reg1 = /http(s)?:\/\/(www.)?(\w+(\.)?)+/;
    let ticketUrl = url.match(reg1)[0];
    ticketUrl = 'https://www.foxitsoftware.com'; // PRO-7640 要求使用固定值
    const {lng} = store.appStore;
    let language = lng.full;//.toLocaleString();
    let identify = APP_IDENTIFIES[app_code];
    let to =  target !=='app-detail' ? APP_TARGETS[target]:'';
    let rs = new Date().getTime();
    let pro = '';
    let distributor = store.accountStore.getDistributorName();
    if(distributor === 'NexstGo'){
      // TODO
      pro = store.accountStore.distributorID;
    }

    let params = {
      language: language, //产品语言 xx-xx
      license: planType, //"yearly", // 或者monthly "yearly"
      rs: rs,//当前的时间戳（时区UTC +0 ），由phantom online网站生成。
      to: to, //"/account/subscription.html" // 跳转地址

    }
    identify && (params['identify'] = identify);
    to && (params['to'] = to);
    pro && (params['pro'] = pro);

    store.userStore.doGetTicket(ticketUrl, (ticket) => {
      ticket && (params['ticket'] = ticket);
      let targetUrl = `${url}?${qs.stringify(params)}`

      let str = HmacMD5(targetUrl, "166e3e236f81cb0191844ae279ebc110").toString(); //str: 以上字段值连接后使用 HMAC 方法生成带有密钥的哈希值
      targetUrl = targetUrl + '&str='+str;
      callback && callback(targetUrl);
    })
  }

  getAppShoppingTargetUrl({app_code = 'phantom_ga_online', planType='yearly', target, original = false }, callback){
    let url = getFoxitStoreDomain()
    
    if(!url){
      return callback && callback('');
    }
    const {lng} = store.appStore;
    let language = lng.full;//.toLocaleString();
    let to = APP_TARGETS[target];
    let ticketUrl = url;
    ticketUrl = 'https://www.foxitsoftware.com'; // PRO-7640 要求使用固定值
    let params = {};
    switch (target) {
      case 'app-detail': // 点击订阅具体产品
        params = {
          identify: APP_IDENTIFIES[app_code],
          language,
          license: planType,
          lang: language
        }
        break;
      case 'my-order': // &license_id=xxxxxxxx&fromClient=0&lang=en-us
        params={lang: language}
        break;
      case 'app-list':
        if (!original) {
          params = {
            identify: APP_IDENTIFIES[app_code],
            language,
            license: planType,
            lang: language
          }
          to = APP_TARGETS['new-app-list'];
          break;
        } else {
          /* falls through */
        }
      case 'my-cards':
        /* falls through */
      case 'my-invoices':
        params={lang: language}
        break;
      default:
        break;
    }

    store.userStore.doGetTicket(ticketUrl, (ticket) => {
      ticket && (params['ticket'] = ticket);
      //let targetUrl = `${url}?${qs.stringify(params)}`
      let targetUrl = `${url}${to}?${qs.stringify(params)}`;
      callback && callback(targetUrl);
    })

  }
}
